import { gql } from "lib/apolloClient";

export const assignBillingTagsToOrganizationMutation = gql`
  mutation assignBillingTagsToOrganization($input: [TagEntityMapInput!]) {
    platform {
      upsertEntityTagsMapping(input: $input) {
        response {
          tagId
          entityId
          entityType
        }
      }
    }
  }
`;

export const removeBillingTagsFromOrganizationMutation = gql`
  mutation removeBillingTagsFromOrganization($input: [TagEntityMapInput!]) {
    platform {
      deleteEntityTagMapping(input: $input) {
        response {
          tagId
          entityId
          entityType
        }
      }
    }
  }
`;

export const createNewBillingTagMutation = gql`
  mutation createNewBillingTag($input: [TagInfoInput!]) {
    platform {
      upsertEntityTags(input: $input) {
        response {
          id
          tag_type
          value
        }
      }
    }
  }
`;
